import { render, staticRenderFns } from "./OrmMessageListSideMenu.vue?vue&type=template&id=79d7c67e&scoped=true"
import script from "./OrmMessageListSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmMessageListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OrmMessageListSideMenu.vue?vue&type=style&index=0&id=79d7c67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7c67e",
  null
  
)

export default component.exports